import { AuthorityType } from '../../model/user/authority-type.enum';
import { Dept } from '../../model/tenant/dept';
import { Group } from '../../model/tenant/group';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NecErrorCollectService } from '../error-collect/error-collect.service';
import { NecLocalStorageService } from '../localStorage/local-storage.service';
import { NecUrl } from './../../model/url/url';
import { Observable } from 'rxjs';
import { Tenant } from '../../model/tenant/tenant';
import { TenantUsableModuleType } from '../../model';
import { User } from '../../model/user/user';
import { UserInterface } from './user.interface';
import { UserPositionInfo } from '../../model/user/user-position-info';


/**
 * è·åå½åç¨æ·ç¸å³ä¿¡æ¯çæå¡
 */
@Injectable()
export class UserService {
  private defaultAvatarUrl = 'assets/images/common/header/default-photo.png';
  private defaultTenantLogoUrl = 'assets/images/common/header/512ks-logo.png';

  readonly LS_USER_INFO = 'userInfo';

  /**
   * userInfoé½å­å¨å¨localStorageä¸­
   */
  constructor(private ls: NecLocalStorageService,
    private errorCollectService: NecErrorCollectService,
    private userInterface: UserInterface) {
  }

  /**
   * è·åæ´ä¸ªuserInfo(ä»ç¼å­ä¸­è·å)
   */
  getUserInfo(): User {
    return this.ls.get(this.LS_USER_INFO);
  }

  /**
   * è·åuser
   */
  getUserInfoFromServer(allowAuthorities?: string[], url = `${NecUrl.SERVER_URL}/server/me`): Observable<User> {
    return this.userInterface.getUserInfo(url)
      .pipe(
        map(result => {
          let userAuthority = this.getAuthority(result);
          if (!allowAuthorities || allowAuthorities && allowAuthorities.indexOf(userAuthority.toLocaleString()) > -1) {
            return result;
          } else {
            throw new Error('ç¨æ·åæå¯ç éè¯¯');
          }
        })
      );
  }

  /**
   * è·åæå±å»é¢ä¿¡æ¯(æ³¨: å¦ææ¯å»é¢ç®¡çååè¿åçæ¯userInfo.me, å ä¸ºåå°è¿åçæ°æ®å°±å¨meä¸­)
   */
  getTenant(): Tenant {
    let userInfo = this.getUserInfo();
    if (userInfo && userInfo.tenant) {
      return userInfo.tenant;
    }
    else if (this.getAuthority() === AuthorityType.ROLE_TENANT) {
      return <Tenant>userInfo.me;
    }
    else {
      return null;
    }
  }

  /**
   * è·åæå±å»é¢çå»é¢Id(æ³¨: å¦ææ¯å»é¢ç®¡çååæ¯è¿åme.id)
   */
  getTenantId(): number {
    if (this.getTenant()) {
      return this.getTenant().id;
    } else {
      return this.getUserInfo().me.id;
    }
  }

  /**
   * è®¾ç½®å½åç¨æ·çä¿¡æ¯, å¸¸ç¨äºç»å½æ¶è·åç¨æ·ä¿¡æ¯åè¿è¡ä¿å­
   */
  setUserInfo(userInfo: User): void {
    this.errorCollectService.init(userInfo);
    this.ls.set(this.LS_USER_INFO, userInfo);
  }

  /**
   * å é¤å½åç¨æ·çä¿¡æ¯, å¸¸ç¨äºç¨æ·éåºç»å½æ¶æ³¨éä¿¡æ¯
   */
  delUserInfo(): void {
    this.ls.del(this.LS_USER_INFO);
  }

  /**
   * è·åå½åç¨æ·çè§è²
   */
  getAuthority(user?: User): AuthorityType {
    let userInfo;
    if (user) {
      userInfo = user;
    } else {
      userInfo = this.getUserInfo();
    }

    if (userInfo && userInfo.account && userInfo.account.authorities && userInfo.account.authorities[0]) {
      for (let i = 0; i < userInfo.account.authorities.length; i++) {
        let isManager = this.getIsManager();
        if (userInfo.account.authorities[i].authority === AuthorityType.ROLE_USER) {
          if (isManager) {
            return AuthorityType.ROLE_DEPT_ADMIN;
          } else {
            return AuthorityType.ROLE_USER;
          }
        }
      }
      return userInfo.account.authorities[0].authority;
    } else {
      return null;
    }
  }

  /**
   * è·åæå±å»é¢logoå¾ççurlå°å
   */
  getTenantLogoUrl(): string {
    let tenant = this.getTenant();

    if (tenant && tenant.logo && tenant.logo.active && tenant.logo.mediaInfo && tenant.logo.mediaInfo.url) {
      return tenant.logo.mediaInfo.url;
    }
    else {
      return this.defaultTenantLogoUrl;
    }
  }

  /**
   * è·åå½åç¨æ·çç¨æ·å
   */
  getUsername(): string {
    let userInfo = this.getUserInfo();

    if (userInfo && userInfo.account) {
      return userInfo.account.username;
    }
    else {
      return '';
    }
  }

  /**
   * è·åå½åç¨æ·ççå®å§å(å¦ææ²¡æè®¾ç½®è¿çå®å§ååè¿åç¨æ·å)
   * å¸¸ç¨äºå³ä¸è§æ¾ç¤ºçç¨æ·åç§°ç­
   */
  getRealName(): string {
    let userInfo = this.getUserInfo();

    if (userInfo && userInfo.me && userInfo.me.realName) {
      return userInfo.me.realName;
    }
    else if (this.getUsername()) {
      return this.getUsername();
    }
    else {
      return '';
    }
  }


  /**
   * è·åå½åç¨æ·çå¤´åå¾çurl(å¦ææ²¡æè®¾ç½®è¿, åè¿åé»è®¤çå¤´åå¾ç)
   */
  getAvatarUrl(): string {
    let userInfo = this.getUserInfo();

    if (userInfo && userInfo.me && userInfo.me.avatarUrl) {
      return userInfo.me.avatarUrl;
    }
    return this.defaultAvatarUrl;
  }

  /**
   * è·åç¨æ·èä½ä¿¡æ¯
   */
  getUserPositionInfo(userId: number, type?: string): Observable<UserPositionInfo> {
    return this.userInterface.getUserPositionInfo(userId, type || 'user');
  }

  /**
   * è·åå¤ä¸ªç¨æ·èä½ä¿¡æ¯
   */
  getMoreUserPositionInfo(userIds: number[], type?: string): Observable<UserPositionInfo> {
    return this.userInterface.getMoreUserPositionInfo(userIds, type || 'user');
  }

  /**
   * æ¥è¯¢å½åç¨æ·æ¯å¦æ¯ç§å®¤ç®¡çå
   * éè¿æ¯å¦å­å¨ç®¡ççdeptæègroupæ¥å¤æ­
   */
  getIsManager(): boolean {
    let userInfo = this.getUserInfo();

    if (!userInfo) {
      return false;
    }
    if (userInfo && userInfo.account && userInfo.account.authorities && userInfo.account.authorities[0]
      && userInfo.account.authorities[0].authority === AuthorityType.ROLE_TENANT) {
      return true;
    }

    if (userInfo.depts && userInfo.depts.length > 0) {
      return true;
    }

    if (userInfo.groups && userInfo.groups.length > 0) {
      return true;
    }

    return false;
  }

  /**
   * æ¥è¯¢å½åç¨æ·æ¯å¦å·²è®¤è¯
   * éè¿æ¯å¦æ¥æèä½ä¿¡æ¯æ¥å¤æ­
   */
  getIsCerified(): boolean {
    let userInfo = this.getUserInfo();

    if (userInfo && userInfo.position) {
      return true;
    }
    else {
      return false;
    }
  }

  /**
   * æ¥è¯¢å½åç¨æ·æç®¡ççç§å®¤åè¡¨
   */
  getDepts(): Dept[] {
    return this.getUserInfo().depts;
  }

  /**
   * æ¥è¯¢å½åç¨æ·æç®¡ççå°ç»åè¡¨
   */
  getGroups(): Group[] {
    return this.getUserInfo().groups;
  }

  /**
   * è·åå½åç¨æ·æå¨å»é¢å¯ä»¥ä½¿ç¨çæ¨¡å
   */
  getTenantUsableModules(): TenantUsableModuleType[] {
    let modules = [];
    let tenant = this.getTenant();
    if (!tenant) {
      return modules;
    } else {
      tenant.modules.forEach((module) => modules.push(TenantUsableModuleType[module]));
    }
    return modules;
  }
}
